import { Typography } from '@sapphire-react/core';
import { formatMoney } from '../../utils';
import { useAnimatedValue } from './useAnimatedValue';

export const LoanAmountHeading = ({ loanAmount }: { loanAmount?: number }) => {
  const animatedLoanAmount = useAnimatedValue(loanAmount);
  const valueToDisplay =
    window.abTestVersion === 'b' ? animatedLoanAmount : loanAmount;

  return (
    <Typography.Heading level={5} data-test-id={'loan-amount-result'}>
      {formatMoney(valueToDisplay)}
    </Typography.Heading>
  );
};
